<script setup lang="ts">
    import { IChatMessage } from '@/js/services/api/chat/chat';
    import ChatMessage from './ChatMessage.vue';
    import AddAsWidget from './AddAsWidget.vue';
    import { computed, onMounted, ref } from 'vue';
    import ParsedMarkdown from '../ParsedMarkdown.vue';

    const props = defineProps<{ message: IChatMessage }>();

    const addAsWidgetContent = ref({});

    onMounted(async () => {
        addAsWidgetContent.value = {
            text: props.message.message,
        };
    });

    const markdown = computed(() => props.message.message as string);
</script>

<template>
    <ChatMessage :message="message" :class="{ 'pr-10': !message.isUserMessage }">
        <AddAsWidget v-if="!message.isUserMessage" widget-type="Text" :data="addAsWidgetContent" />
        <ParsedMarkdown :markdown="markdown" />
    </ChatMessage>
</template>
